module.exports = __webpack_public_path__ + "img/VolumeOff.f1d65eff.svg";